import { createNames } from "../../utils";
export const getAceSelectNames = (id) => {
    return createNames(id, 'ACE-SELECT', '____UP', '____ERROR', '____IS_OPEN', '____DISABLED', '____PLACEHOLDER', 'INPUT', 'INPUT____WITH_TEMPLATE', 'DROPDOWN_TOGGLE', 'OPTION', 'OPTION____SELECTED', 'OPTION____WITH_TEMPLATE', 'WRAPPER', 'CONTAINER', 'OPTIONS', 'LABEL', 'ERRORS_WRAPPER');
};
export const aceSelectCssVariables = {
    MIN_WIDTH: '--ace-select-min-width',
    SELECTION_HEIGHT: '--ace-select-selection-height',
};
//# sourceMappingURL=ace-select.get-names.js.map
